<script lang="ts">
  import { observeTagOverflow } from "../../_logic/tag-overflow"
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import {
    buildRichTooltip,
    tooltipText,
    RICH_TOOLTIP_CLASS,
  } from "../../../../../_shared/_logic/rich-tooltips"
  import type { WorkOrderSummaryTagPresentation } from "../../_logic/summary-tag"

  type Props = {
    tag: WorkOrderSummaryTagPresentation | null
    disabled?: boolean
    fallbackLabel?: string | null
  }

  const { tag, disabled = false, fallbackLabel = "—" }: Props = $props()
  let overflowing = $state(false)
</script>

{#if tag}
  <span
    class:disabled
    use:observeTagOverflow={(value) => {
      overflowing = value
    }}
  >
    <StatusTag
      variant="neutral"
      size="sm"
      label={tag.label}
      iconText={tag.numberLabel}
      subLabel={tag.subLabel ?? undefined}
      color={tag.color}
      tooltipContent={buildRichTooltip([
        overflowing && tag.fullLabel === tag.label ? tooltipText(tag.fullLabel) : null,
        tag.tooltip,
      ])}
      tooltipHtml={true}
      tooltipClassName={RICH_TOOLTIP_CLASS}
      disableTitle={true}
    />
  </span>
{:else}
  <span class="summary-tag__fallback" class:disabled>{fallbackLabel || "—"}</span>
{/if}

<style lang="less">
  span {
    display: inline-flex;
    max-width: 100%;
  }

  span.disabled {
    opacity: 0.58;
  }

  .summary-tag__fallback {
    color: var(--text-100);
    font-weight: 600;
  }

  .summary-tag__fallback.disabled {
    color: var(--text-50);
    font-weight: 500;
  }
</style>
